import React from "react";
import { connect } from "react-redux";
import Modal from "src/components/modal/modal";
import { IFile } from "src/features/fileManagement/data/models/file";
import { Modals } from "src/helpers";
import { IRootState } from "src/store";

interface ImagePreviewPopupProps {
  itemSelected?: IFile;
}

class ImagePreviewPopup extends React.Component<ImagePreviewPopupType> {
  render() {
    const file = this.props.itemSelected;

    return (
      <Modal
        id="file-management-image-preview-popup"
        dialogExtraClassName="file-management-image-preview-popup"
        isShow={this.props.currentModal === Modals.FILE_MANAGEMENT_IMAGE_PREVIEW}
      >
        <h4 className="text_center overflow">{file?.name}</h4>
        <img src={file?.url} alt={file?.name ?? ""} className="file-management-image-preview" />
      </Modal>
    );
  }
}

const mapStateToProps = ({ app }: IRootState) => {
  const { currentModal } = app;

  return {
    currentModal,
  };
};

type ImagePreviewPopupType = ImagePreviewPopupProps & ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps)(ImagePreviewPopup);
